import type { SegmentCategoriesAdapter } from "@/store/slices/segments/segmentsSlice";

export function getAgeRangeMinMaxValueBasedOnCountryCode(countryCode: string) {
  if (countryCode === "HSS" || countryCode?.startsWith("HSS")) {
    return { min: 35, max: 120 };
  } else if (
    countryCode === "Spirit Drinkers" ||
    countryCode?.startsWith("CTM-CA") ||
    countryCode === "Gallo" ||
    countryCode?.startsWith("CTM-GL")
  ) {
    return { min: 21, max: 120 };
  } else {
    return { min: 18, max: 120 };
  }
}

export const getAgeSegmentsNameBasedOnMarket = (selectedMarkets: string[]) => {
  if (selectedMarkets.every((obj) => obj === "HSS" || obj?.includes("HSS"))) {
    return "Age 35+";
  } else if (
    selectedMarkets.every(
      (obj) => obj === "Spirit Drinkers" || obj?.includes("CTM-CA")
    ) ||
    selectedMarkets.every(
      (obj: any) =>
        obj === "Gallo" || obj?.includes("CTM-GL"),
    )
  ) {
    return "Age 21+";
  } else if (
    selectedMarkets.every(
      (obj) => obj === "A&A Management" || obj?.includes("CTM-AA")
    )
  ) {
    return "Age 18-64";
  } else {
    return "Age 18+";
  }
};

export function getFilterOptionsSelected(
  filter: Record<number, number[]>
): number[] {
  if (!filter) {
    return [];
  }
  const result = Object.values(filter)?.reduce(
    (acc: number[], curr: number[]) => {
      return [...acc, ...curr];
    },
    []
  );
  return result;
}

export function getSelectedFilterObjectForSegmentFilter(segmentFilters: any) {
  let result: Record<number, Record<number, number[]>> = [];
  const ageRange: number[] = [];
  segmentFilters?.forEach((segmentFilter: any) => {
    if (segmentFilter?.filterId === 8) {
      if (segmentFilter?.filterOptions?.length > 1) {
        ageRange.push(segmentFilter?.filterOptions[0]?.filterOptionId);
        ageRange.push(segmentFilter?.filterOptions[1]?.filterOptionId);
      }
    } else {
      if (result[segmentFilter.categoryId]) {
        result = {
          ...result,
          [segmentFilter.categoryId]: {
            ...result[segmentFilter.categoryId],
            [segmentFilter.filterId]: segmentFilter.filterOptions.map(
              (f: any) => f.filterOptionId
            ),
          },
        };
      } else {
        result = {
          ...result,
          [segmentFilter.categoryId]: {
            [segmentFilter.filterId]: segmentFilter.filterOptions.map(
              (f: any) => f.filterOptionId
            ),
          },
        };
      }
    }
  });
  return { filtersDetails: result, ageRange };
}

 export function getSegmentReorderRequestPayload(
    categoryId: number,
    segmentIds: number[],
    segmentsCategories:SegmentCategoriesAdapter
  ) {
    const allSegmentsInThisCategory = segmentsCategories.entities[categoryId]?.segmentIds || [];

    const activeSegmentsInThisCategoryOrdered = segmentIds.filter(id =>
      allSegmentsInThisCategory.includes(id)
    );

    const inactiveSegmentsInThisCategory = allSegmentsInThisCategory.filter(
      id => !activeSegmentsInThisCategoryOrdered.includes(id)
    );

    const newCategoryOrder = [
      ...activeSegmentsInThisCategoryOrdered,
      ...inactiveSegmentsInThisCategory,
    ];

    let result: number[] = [];
    segmentsCategories.ids?.forEach((id:number) => {
      if (id === categoryId) {
        result = [...result, ...newCategoryOrder];
      } else {
        result = [...result, ...segmentsCategories.entities[id].segmentIds];
      }
    });
    const requestPayload: {
      segmentId: number;
      position: number;
    }[] = result.map((r: number, index: number) => ({
      segmentId: r,
      position: index,
    }));
    return requestPayload;
  }
